module.exports = "<ng-transclude class=\"toggleButtonGroup {{ ::$ctrl.groupClass }}\"/>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/common/togglebuttongroup/toggle-button-group.component.html
// module id = 888
// module chunks = 1